import React from "react";
import {createRoot} from "react-dom/client";
import Main from './Components/Main';

class GoogleFontsScan extends HTMLElement {
    constructor() {
        super();

        const apiBase =  this.dataset['url'] || '';
        const premium = 'premium' in this.dataset;
        const shadow = this.attachShadow({mode: 'open'});

        const styles = document.createElement('link');
        styles.setAttribute('rel', 'stylesheet');
        styles.setAttribute('href',  apiBase + '/build/assets/app.css');
        shadow.appendChild(styles);

        this.style.fontWeight = 400;
        this.style.fontSize = "16px";
        this.style.lineHeight = "normal";
        document.querySelector('html').style.fontSize = "16px";

        const widgetRoot = document.createElement('div');
        (new MutationObserver( () => typeof scannerCallback === 'function' ? scannerCallback() : null ))
            .observe(widgetRoot, { childList: true, subtree: true });

        styles.onload = () => {
            const root = createRoot(widgetRoot)
            root.render(
                <Main apiBase={apiBase} premium={premium} />
            );

            shadow.appendChild(widgetRoot);
        };
    }
}

customElements.define('google-fonts-scan', GoogleFontsScan);
